import { ArrowUpRight } from "lucide-react";

/**
 * Secondary footer rendered beneath the main theme footer on every page —
 * "© {year} Powered by <logo> Aitisal ↗" linking to aitisaltech.com.
 */
export default function SecondaryFooter() {
  return (
    <footer className="w-full bg-white border-0 border-gray-200 border-t">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-1.5 gap-y-1 px-4 py-3">
        <span className="text-[13px] text-gray-500">
          © {new Date().getFullYear()} Powered by
        </span>
        <img
          src="/icons/aitisal-app-logo.svg"
          alt="Aitisal logo"
          className="h-4 w-auto"
          loading="lazy"
          style={{ width: "20px" }}
        />
        <a
          href="https://www.aitisaltech.com/"
          target="_blank"
          rel="nofollow sponsored noopener noreferrer"
          className="group inline-flex items-center gap-0.5 text-[13px] font-semibold text-gray-800 underline underline-offset-2 transition-colors hover:text-gray-900"
        >
          Aitisal
          <ArrowUpRight
            className="size-3.5 opacity-70 transition-opacity group-hover:opacity-100"
            strokeWidth={1.5}
          />
        </a>
      </div>
    </footer>
  );
}
